import type { UsageQueryParams } from "./types";

/** Builds the query-string suffix (e.g. `?dateFrom=...&limit=...`) for AI usage endpoints. */
export const usageQuery = (p: UsageQueryParams = {}) => {
  const q = new URLSearchParams();
  if (p.dateFrom) q.set('dateFrom', p.dateFrom);
  if (p.dateTo) q.set('dateTo', p.dateTo);
  if (p.limit != null) q.set('limit', String(p.limit));
  if (p.offset != null) q.set('offset', String(p.offset));
  const s = q.toString();
  return s ? `?${s}` : '';
};
